import { DocumentType } from "models"

export interface DocumentLike {
    name?: string | null
    documentType?: DocumentType | null
}

const getLowerName = (document: DocumentLike): string => (document.name ?? "").toLowerCase()

const getExtension = (fileName: string): string | null => {
    const lastDot = fileName.lastIndexOf(".")
    if(lastDot <= 0 || lastDot === fileName.length - 1) {
        return null
    }

    return fileName.slice(lastDot + 1).toLowerCase()
}

export const isDocumentImageLike = (document: DocumentLike): boolean => {
    const extension = getExtension(getLowerName(document))
    return document.documentType === DocumentType.PHOTO ||
        extension === "png" ||
        extension === "jpg" ||
        extension === "jpeg" ||
        extension === "webp" ||
        extension === "gif"
}

export const resolveDocumentLabel = (document: DocumentLike): string => {
    const extension = getExtension(getLowerName(document))

    if(document.documentType === DocumentType.PHOTO) {
        return "IMG"
    }

    if(document.documentType === DocumentType.PLANIMETRY) {
        return "PLAN"
    }

    if(extension === "pdf") {
        return "PDF"
    }

    if(extension === "zip" || extension === "rar" || extension === "7z") {
        return "ARCHIVE"
    }

    if(extension === "doc" || extension === "docx") {
        return "DOC"
    }

    if(extension === "xls" || extension === "xlsx") {
        return "XLS"
    }

    if(extension === "ppt" || extension === "pptx") {
        return "PPT"
    }

    if(extension === "txt") {
        return "TXT"
    }

    if(extension) {
        return extension.toUpperCase()
    }

    return document.documentType === DocumentType.ATTACHMENT ? "ATTACHMENT" : "FILE"
}
